<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Release Notes</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <div class="OmsTitle">ShuttleNomix</div>
    <div class="OmsTagLine" data-test="tagline">Release Notes</div>
    <div class="OmsIntroduction">
        <div class="OmsPreamble">
            <ion-accordion-group>
                <ion-accordion value="first">
                    <ion-item slot="header" color="secondary">
                        <ion-label color="light" class="OmsLegend">Legend</ion-label>
                    </ion-item>
                    <div slot="content">
                        <div class="OmsDescription">
                            With every release ShuttleNomix improves just a little bit. This release note describes
                            which
                            specific bugs were fixed, which features were added and what cosmetic changes were made
                            since
                            the last release. All changes will be categorized by their type of issue: <br />
                            <ul class="OmsIntroductionUL">
                                <li>
                                    <strong>New Features: </strong>Items in this category will denote all the features
                                    that have been added to this version that provides additional functionality.
                                </li>
                                <br />
                                <li>
                                    <strong>Bug Fixes: </strong>Items in this category will denote those changes that
                                    improve the functionality or performance of already existing features.
                                </li>
                                <br />
                                <li>
                                    <strong>Cosmetics: </strong>Items in this category will denote those changes that
                                    improve the appearance such as color changes and layout changes. Overall, these
                                    changes will aid in a more pleasant user experience.
                                </li>
                                <br />
                                <li>
                                    <strong>Documentation: </strong>Items in this category will denote those
                                    changes that improve readability such as spelling and grammatical changes, and
                                    changes to the documentation and online help. Overall, these changes will
                                    shorten the learning curve.
                                </li>
                            </ul>
                        </div>
                    </div>
                </ion-accordion>
            </ion-accordion-group>
        </div>
    </div>

    <div class="body" [innerHTML]="myHTML"></div>
</ion-content>

<!-- 
<ion-content class="ion-no-padding">
    <div class="Preamble">
        <div class="Title">ShuttleNomix Release Notes</div>
        <p class="Description">
            With every release ShuttleNomix improves just a little bit.  This release note describes which 
            specific bugs were fixed, which features were added and what cosmetic changes were made since 
            the last release.
        </p>

        <div ion-text-wrap>
            @for (issue of releases; track $index) {
  <div class="AllSections ion-no-padding">
                <div class="ion-no-padding"  class="Issue">
                    <div class="Title">{{issue.version}} - {{issue.releaseDate}}</div>
                    @for (delta of issue.deltas; track $index) {
  <div class="ion-no-padding" class="Deltas">
                        <div class="Delta">
                            <div class="Category">{{delta.category}}</div>
                            <div>
                                @for (change of delta.changes; track $index) {
  <div class="ion-no-padding DeltaItem">
                                    <div class="IssueNumber"><strong>Issue #{{change.issueNumber}}</strong></div>
                                    <div class="IssueDescription">{{change.description}}</div>
                                </div>
}
                            </div>
                        </div>
                    </div>
}
                </div>
            </div>
}
        </div>
    </div>
</ion-content> -->